import { OTHER_ACTIONS, REDUCERS } from '../../constants.js';

const initialOtherActionState = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  action : OTHER_ACTIONS.NONE,
}

const otherActions = (state = initialOtherActionState, action) => {
  switch (action.type) {
    case OTHER_ACTIONS.UPDATE_WB_INFO:
      return {  action : OTHER_ACTIONS.UPDATE_WB_INFO, workBarUpdate : action.workBarAction };
    case OTHER_ACTIONS.MARK_CALL:
      return {  action : OTHER_ACTIONS.MARK_CALL };
    case OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS:
    return {  action : OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS};  
    default:
      return state;
  }
}

export default otherActions;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_other_actions.js